import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class AuthLayoutComponent {}
